import React from "react";
import Navigation from "../components/Navigation";

const InvestScreenLoggedIn = () => {
  // Mock investments
  const investments = [
    {
      symbol: "AAPL",
      name: "Apple Inc.",
      shares: 10,
      value: "$1,500.00",
      change: "+$50.00",
      changePercent: "+3.45%",
    },
    {
      symbol: "TSLA",
      name: "Tesla Inc.",
      shares: 5,
      value: "$1,200.00",
      change: "-$30.00",
      changePercent: "-2.44%",
    },
  ];

  return (
    <div className="screen">
      <Navigation />
      <div className="screen-header" style={{ marginTop: 56 }}>
        <h1 className="screen-title">Your Investments</h1>
        <p className="screen-subtitle">Manage and track your portfolio</p>
      </div>
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Investment List</h3>
        </div>
        <div className="grid-2">
          {investments.map((inv, idx) => (
            <div key={idx} className="stock-item">
              <div className="stock-header">
                <div>
                  <div className="stock-name">{inv.name}</div>
                  <div className="stock-symbol">{inv.symbol}</div>
                </div>
                <div className="text-right">
                  <div className="stock-price">{inv.value}</div>
                  <div
                    className={`stock-change ${
                      inv.changePercent.startsWith("+")
                        ? "positive"
                        : "negative"
                    }`}
                  >
                    {inv.change} ({inv.changePercent})
                  </div>
                  <div className="stock-shares">{inv.shares} shares</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      {/* Quick Actions */}
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Quick Actions</h3>
        </div>
        <div className="grid-2">
          <button
            onClick={() => window.location.href = "/add-investment"}
            className="btn btn-large"
          >
            ➕ Add Investment
          </button>
          <button
            onClick={() => window.location.href = "/add-transaction"}
            className="btn btn-secondary btn-large"
          >
            💰 Add Transaction
          </button>
          <button
            onClick={() => window.location.href = "/import-transactions"}
            className="btn btn-outline btn-large"
          >
            📤 Import Transactions
          </button>
          <button
            onClick={() => window.location.href = "/transaction-history"}
            className="btn btn-outline btn-large"
          >
            📋 View History
          </button>
        </div>
      </div>
    </div>
  );
};

export default InvestScreenLoggedIn;
